var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAllUserActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4911_6258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4679 18.1666H3.55714C3.53802 18.1484 3.51897 18.1301 3.5 18.1116C4.23984 17.706 4.63277 17.271 5.00516 16.8588C5.44557 16.3713 5.85725 15.9156 6.78007 15.5778C8.24314 15.0667 8.45794 14.9916 8.40749 13.7822C8.38288 13.4052 8.29529 13.3188 8.15934 13.1846C8.01646 13.0436 7.82018 12.8499 7.58747 12.211C7.5856 12.2054 7.58366 12.1996 7.58165 12.1937C7.52947 12.0385 7.43093 11.7454 7.29731 11.6374C6.99453 11.3007 6.23759 10.4153 6.61606 9.20576C6.75623 8.74396 6.74413 8.68577 6.68742 8.41304C6.66756 8.31755 6.64224 8.19576 6.61606 8.02114C6.47729 7.14826 6.45206 5.8514 6.8053 4.94111C7.46131 3.28263 9.05088 2.39728 11.246 2.50951C12.259 2.55719 12.5598 2.77706 12.8799 3.01097C13.062 3.1441 13.2504 3.28179 13.5799 3.39486C15.2073 3.93106 15.8886 5.70176 15.3713 8.13337C15.3295 8.31732 15.2878 8.44024 15.2553 8.53581C15.1799 8.7577 15.1545 8.8322 15.2956 9.18083C15.5101 9.74196 15.3966 10.2532 15.2578 10.7021C15.1144 11.1745 15.0389 11.2219 14.9403 11.2838C14.8305 11.3527 14.6922 11.4396 14.3999 12.1486C14.222 12.5655 13.9994 12.8598 13.8236 13.0921C13.6629 13.3046 13.5415 13.4652 13.5294 13.6201C13.366 14.9623 13.8793 15.1526 15.3816 15.7094L15.3966 15.715C15.689 15.8201 16.2896 16.3378 16.9216 16.8825C17.4892 17.3717 18.0822 17.8828 18.5 18.1365C18.4893 18.1466 18.4786 18.1566 18.4679 18.1666Z",
    fill: "#FAAA52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 10.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#FAAA52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 10.5,
    width: 13,
    height: 13,
    rx: 6.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1319 19.1616L21.1319 19.1616L21.131 19.1607L19.7406 17.7703C19.9782 17.3673 20.1211 16.901 20.1211 16.3979C20.1211 14.894 18.902 13.675 17.398 13.675C15.8941 13.675 14.675 14.894 14.675 16.3979C14.675 17.9019 15.8941 19.1209 17.398 19.1209C17.9011 19.1209 18.3673 18.978 18.77 18.7408L20.1609 20.1312L20.1609 20.1312L20.1618 20.1321C20.2912 20.2572 20.4646 20.3265 20.6446 20.325C20.8246 20.3234 20.9969 20.2512 21.1241 20.1239C21.2514 19.9966 21.3235 19.8243 21.325 19.6443C21.3264 19.4643 21.2571 19.2909 21.1319 19.1616ZM17.398 18.1561C16.4271 18.1561 15.6398 17.3689 15.6398 16.3979C15.6398 15.427 16.4271 14.6398 17.398 14.6398C18.369 14.6398 19.1563 15.427 19.1563 16.3979C19.1563 17.3689 18.369 18.1561 17.398 18.1561Z",
    fill: "#FFEFDE",
    stroke: "#FFEFDE",
    strokeWidth: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4911_6258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAllUserActive);
export default __webpack_public_path__ + "static/media/Icon.AllUserActive.c25167d1765fd88ee2bee9714fa39c28.svg";
export { ForwardRef as ReactComponent };